import { render, staticRenderFns } from "./GroupsTreeMultiSelectFilter.vue?vue&type=template&id=6870bf3c&scoped=true&"
import script from "./GroupsTreeMultiSelectFilter.vue?vue&type=script&lang=js&"
export * from "./GroupsTreeMultiSelectFilter.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTreeMultiSelectFilter.vue?vue&type=style&index=0&id=6870bf3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870bf3c",
  null
  
)

export default component.exports